import {
    CmpsFormField,
    CmpsFormFields,
} from '../../../common/experimental.form';

export interface SelectedGoalFormFieldsModel extends CmpsFormFields {
    CURRENT_ACTUAL: CmpsFormField;
    EXPECTED_ACHIEVEMENT_DATE: CmpsFormField;
    PERCENT_GAP_TO_TARGET: CmpsFormField;
    PERCENT_IMPROVEMENT_EXPECTED: CmpsFormField;
    GOAL_VALUE: CmpsFormField;
    START_PERCENT_TO_GOAL: CmpsFormField;
}

export const SelectedGoalFormFields: SelectedGoalFormFieldsModel = {
    CURRENT_ACTUAL: {
        name: 'currentActual',
        label: '',
    },
    EXPECTED_ACHIEVEMENT_DATE: {
        name: 'expectedAchievementDate',
        label: '',
    },
    PERCENT_GAP_TO_TARGET: {
        name: 'percentGapToTarget',
        label: '',
    },
    PERCENT_IMPROVEMENT_EXPECTED: {
        name: 'percentImprovementExpected',
        label: '',
    },
    GOAL_VALUE: {
        name: 'goalValue',
        label: '',
    },
    START_PERCENT_TO_GOAL: {
        name: 'startPercentToGoal',
        label: '',
    },
};

export interface SelectedGoalFormValue {
    currentActual: string;
    expectedAchievementDate: Date;
    goalValue: string;
    percentGapToTarget: string;
    percentImprovementExpected: string;
    startPercentToGoal: string;
}
